import { render, staticRenderFns } from "./IconSvgAFPMSummit2023.vue?vue&type=template&id=020a4b8c&scoped=true&"
import script from "./IconSvgAFPMSummit2023.vue?vue&type=script&lang=js&"
export * from "./IconSvgAFPMSummit2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a4b8c",
  null
  
)

export default component.exports